export const submitCode = {
	defaultRootURL: "https://spark.mizarvision.com/spark/",
	imgURL: "https://file.mizarvision.com/image/",
	openResourceURL: "https://file.mizarvision.com/open/",
	targetDetectionImgURL: "https://image.mizarvision.com/img/",
	musicURL: "https://image.mizarvision.com/music/",
	geoserverURL: "https://geoserver.mizarvision.com/"
}
export const preCode = {
	defaultRootURL: "https://frame.mizarvision.com/frame/",
	imgURL: "https://file.mizarvision.com/image/",
	openResourceURL: "https://file.mizarvision.com/open/",
	targetDetectionImgURL: "https://image.mizarvision.com/img/",
	musicURL: "https://image.mizarvision.com/music/",
	geoserverURL: "https://geoserver.mizarvision.com/"
}
export const code = {
	defaultRootURL: "http://192.168.3.240:8123/globalfootprintmap/",
	imgURL: "https://file.mizarvision.com/image/",
	openResourceURL: "https://file.mizarvision.com/open/",
	targetDetectionImgURL: "https://image.mizarvision.com/img/",
	musicURL: "https://image.mizarvision.com/music/",
	geoserverURL: "https://geoserver.mizarvision.com/"
}
export const code1 = {
	defaultRootURL: "http://192.168.3.195:8123/globalfootprintmap/",
	imgURL: "https://file.mizarvision.com/image/",
	openResourceURL: "https://file.mizarvision.com/open/",
	targetDetectionImgURL: "https://image.mizarvision.com/img/",
	musicURL: "https://image.mizarvision.com/music/",
	geoserverURL: "https://geoserver.mizarvision.com/"
}
export const code2 = {
	defaultRootURL: "http://192.168.3.19:8088/globalfootprintmap/",
	imgURL: "https://file.mizarvision.com/image/",
	openResourceURL: "https://file.mizarvision.com/open/",
	targetDetectionImgURL: "https://image.mizarvision.com/img/",
	musicURL: "https://image.mizarvision.com/music/",
	geoserverURL: "https://geoserver.mizarvision.com/"
}
export const offline = {
	defaultRootURL: "http://21.145.208.119:9333/globalfootprintmap/",
	// defaultRootURL: "http://192.168.3.9:8123/globalfootprintmap/",
	imgURL: "https://file.mizarvision.com/image/",
	openResourceURL: "https://file.mizarvision.com/open/",
	targetDetectionImgURL: "https://image.mizarvision.com/img/",
	musicURL: "https://image.mizarvision.com/music/",
	geoserverURL: "https://geoserver.mizarvision.com/"
}
export const code4 = {
	defaultRootURL: "http://192.168.3.145:8123/globalfootprintmap/",
	imgURL: "https://file.mizarvision.com/image/",
	openResourceURL: "https://file.mizarvision.com/open/",
	targetDetectionImgURL: "https://image.mizarvision.com/img/",
	musicURL: "https://image.mizarvision.com/music/",
	geoserverURL: "https://geoserver.mizarvision.com/"
}